<template>
  <div class="catalog-picker">
    <!-- Filtro -->
    <v-text-field
      v-model="search"
      label="Filtrar..."
      prepend-inner-icon="mdi-magnify"
      dense
      outlined
      clearable
      hide-details
      :color="color"
      class="mb-2"
    ></v-text-field>

    <!-- Lista de opções (checkboxes do catálogo) -->
    <div class="options-list" :style="{ borderColor: color + '33' }">
      <div v-if="loading" class="py-3 text-center">
        <v-progress-circular indeterminate size="22" width="2" :color="color" />
      </div>
      <template v-else>
        <v-checkbox
          v-for="item in filteredCatalog"
          :key="item.id"
          :input-value="isChecked(item)"
          :label="item.name"
          :color="color"
          dense
          hide-details
          class="opt-check mt-0"
          @change="toggle(item)"
        ></v-checkbox>
        <p
          v-if="filteredCatalog.length === 0"
          class="caption grey--text text-center py-2 mb-0"
        >
          Nenhuma opção encontrada.
        </p>
      </template>
    </div>

    <!-- Outro: quando marcado, mostra o campo de texto livre -->
    <v-checkbox
      v-model="outroChecked"
      label="Outro"
      :color="color"
      dense
      hide-details
      class="mt-2"
    ></v-checkbox>

    <div v-if="outroChecked" class="outro-box mt-1">
      <v-text-field
        v-model="outroText"
        label="Outro (digite e adicione)"
        placeholder="Digite e pressione Enter"
        dense
        outlined
        hide-details
        :color="color"
        append-outer-icon="mdi-plus"
        @keyup.enter="addOutro"
        @click:append-outer="addOutro"
      ></v-text-field>
      <div v-if="outroItems.length" class="mt-2">
        <v-chip
          v-for="(o, i) in outroItems"
          :key="'outro-' + i"
          class="ma-1"
          small
          :color="color"
          text-color="white"
          close
          @click:close="removeSelected(o)"
        >
          <span class="ds-chip-label" :title="o.name">{{ o.name }}</span>
        </v-chip>
      </div>
    </div>

    <!-- Contagem -->
    <p v-if="model.length" class="caption mt-2 mb-0" :style="{ color }">
      {{ model.length }} selecionado(s)
    </p>
  </div>
</template>

<script>
export default {
  name: "CatalogCheckboxPicker",

  props: {
    // Itens selecionados (v-model): [{ name, catalog_id|null }]
    value: { type: Array, default: () => [] },
    // Catálogo vindo do banco: [{ id, name }]
    catalog: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    color: { type: String, default: "#3E8E73" },
  },

  data() {
    return {
      search: "",
      outroChecked: false,
      outroText: "",
    };
  },

  computed: {
    model() {
      return this.value;
    },

    filteredCatalog() {
      if (!this.search) return this.catalog;
      const q = this.search.toLowerCase();
      return this.catalog.filter((o) => (o.name || "").toLowerCase().includes(q));
    },

    // Itens "Outro" já selecionados (sem catalog_id).
    outroItems() {
      return this.model.filter((s) => !s.catalog_id);
    },
  },

  methods: {
    isChecked(item) {
      return this.model.some((s) => s.catalog_id === item.id);
    },

    toggle(item) {
      if (this.isChecked(item)) {
        this.emit(this.model.filter((s) => s.catalog_id !== item.id));
      } else {
        this.emit([...this.model, { name: item.name, catalog_id: item.id }]);
      }
    },

    addOutro() {
      const name = (this.outroText || "").trim();
      if (!name) return;
      // Evita duplicar (case-insensitive) contra o que já está selecionado.
      const exists = this.model.some(
        (s) => (s.name || "").toLowerCase() === name.toLowerCase(),
      );
      if (!exists) {
        this.emit([...this.model, { name, catalog_id: null }]);
      }
      this.outroText = "";
    },

    removeSelected(item) {
      this.emit(this.model.filter((s) => s !== item));
    },

    emit(next) {
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.options-list {
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 6px 10px;
}
.opt-check :deep(.v-label) {
  font-size: 13px;
}
.options-list::-webkit-scrollbar {
  width: 6px;
}
.options-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
</style>
